<template>
    <div class="wp">
         <com-header :type="1" tip="用户注册"></com-header>
         <div class="register-1">
             <div class="register-form">
                 <div class="left">
                     <p class="p1">用户注册协议</p>
                     <div class="content">
                        1、用户的帐号，密码和安全性，您一旦提交注册申请，您将会成为本平台用户，请认真保管好自己的帐号和密码，不得将账号和密码外借其他人，如有此行为带来的损失将自行负全部责任。
                         <br/>
                         <br/>
                        2、用户注册后，通过合法账号登录平台进行所有合法活动。您可以随时更改您的密码，但您在本平台自始至终只能拥有一个唯一帐户，不能多次注册新的帐户，如果您忘记了您的密码，请单击“忘记密码”来重置您的密码，如果您忘记了登录账号。用户同意若发现任何非法使用用户帐号或安全漏洞的情况，立即公告平台。
                        <br/>
                         <br/>
                        3、用户单独承担发布内容的责任。用户对服务的使用是根据所有适用于服务的地方法律，国家法律和国际法律标准的。用户承诺：
                         <br/>
                         <br/>
                            （1）在平台提交的信息或利用平台的服务时必须符合中国有关法规，不得在平台的网页上或利用平台的服务制作，复制，发布，传播以下信息：
                         <br/>
                        （a）反对宪法所确定的基本原则的；<br/>
                        （b）危害国家安全，确立国家秘密，颠覆国家政权，破坏国家统一的；<br/>
                        （c）损害国家荣誉和利益的；<br/>
                        （d）煽动民族仇恨，民族歧视，破坏民族团结的；<br/>
                        （e）破坏国家宗教政策，宣扬邪教和封建迷信的；<br/>
                        （f）散布谣言，扰乱社会秩序，破坏社会稳定的；<br/>
                        （g）散布淫秽，色情，罚款，暴力，凶杀，恐怖或教唆犯罪的；<br/>
                        （h）侮辱他人或侵害他人合法权益；<br/>
                        （i）包含法律，行政法规禁止的其他内容的。<br/>
                         <br/>
                        （2）在平台的网页上发布信息或者利用平台的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。
                         <br/>
                         <br/>
                        （3）不利用平台的服务从事以下活动：
                         <br/>
                        （a）未经允许，进入计算机信息网络或者使用计算机信息网络资源的;<br/>
                        （b）未经允许，对计算机信息网络功能进行删除，修改或者增加的;<br/>
                        （c）未经允许，对进入计算机信息网络中存储，处理或者传输的数据和应用程序进行删除，修改或者增加的;<br/>
                        （d）故意制作，传播计算机病毒等破坏性程序的;<br/>
                        （e）其他危害计算机信息网络安全的行为;<br/>
                         <br/>
                        （4）不以任何方式干扰平台的服务。
                          <br/>
                         <br/>
                        （5）遵守平台的所有其他规定和程序。用户需对自己在使用平台服务过程中的行为承担法律责任。用户理解，如果平台发现其网站传输的信息明显属于上段第（1）条码内容之一，依据中国法律，平台有义务立即停止传输，保存有关记录，向国家有关机关报告，并删除包含该内容的地址，目录或关闭服务器。用户使用平台电子公告服务，包括电子布告牌，电子白板，电子论坛，网络聊天室和留言板等以交互形式为上网用户提供信息发布条件的行为，也必须遵守本条的规定以及平台将专门发布的电子公告服务规则，上段中描述的法律后果和法律责任同样适用于电子公告服务的用户。若用户的行为不符合以上提到的服务条款，平台将做出独立判断立即取消用户服务帐号。
                     </div>
                 </div>
                 <div class="right">
                     <p class="p1"> 用户注册</p>
                     <el-form ref="form" style="width:80%;margin:0 auto;" :rules="rules" :model="form" >
                        <el-form-item prop="userName">
                            <el-input v-model="form.userName" prefix-icon="el-icon-user" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input v-model="form.password" type="password" prefix-icon="el-icon-unlock" placeholder="请输入密码"></el-input>
                        </el-form-item>
                       <el-form-item prop="confirmPassword">
                            <el-input v-model="form.confirmPassword" type="password" prefix-icon="el-icon-lock" placeholder="请再次输入密码"></el-input>
                        </el-form-item>
                        <el-form-item prop="email">
                            <el-input v-model="form.email" prefix-icon="el-icon-message" placeholder="请输入绑定邮箱"></el-input>
                        </el-form-item>
                        <el-form-item >
                            <el-input v-model="form.yzm" style="width:180px;" prefix-icon="el-icon-circle-check" placeholder="请输入邮箱验证码"></el-input>
                            <el-button type="primary"  style="margin-left:20px;" :loading="buttonLoading" @click="getYzm">{{buttonText}}</el-button>
                        </el-form-item>
                        
                         <el-form-item>
                            <el-checkbox v-model="radio">我已阅读并同意用户注册协议</el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" style="width:100%;" @click="onSubmit">确认注册</el-button>
                        </el-form-item>
                         <el-form-item>
                            <p class="pointer" style="color:#409EFF;width:130px;float:right;" @click="routerToUrl('/login')">已有账号，登录<img style="position:relative;top:7px;left:5px;" src="../../../assets/image/login/letgo.png"></p>
                        </el-form-item>
                        </el-form>
                 </div>
             </div>
         </div>
         <com-footer></com-footer>
    </div>
</template>
<script>
import Register from './Register.js';
export default Register;
</script>
<style lang="scss" scoped>
@import './Register.scss';
</style>